// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__T_9Pn","text":"Error_text__1crp0","link":"Error_link__Tixq4"};